import { sessionLogin } from "@api/v1/methods/sessionLogin";
import { useMutation } from "@tanstack/react-query";

export interface LoginParams {
  email: string;
  password: string;
  rememberMe?: boolean;
}

export interface LoginResponse {}

export const useSessionLogin = () => useMutation({ mutationFn: sessionLogin });
